export const useWebParts = () => {

  const isWebParts = computed(() => {
    const route = useRoute()
    return route.path === '/webparts' || route.path === '/en/webparts'
  })

  return { isWebParts }

}
